import React, { useState, useEffect, useCallback, useContext } from "react";
import Dashboard from "../../ui/Dashboard";
import { AuthContext } from "../../../context/AuthContext";

const serverUrl = process.env.REACT_APP_serverUrl || "";

// Reusable error box
const ErrorBox = ({ error, onRetry }) => (
  <div
    style={{
      padding: "1.5rem",
      border: "1px solid #f87171",
      borderRadius: 10,
      background: "#fef2f2",
    }}
  >
    <h3 style={{ margin: 0, color: "#b91c1c", fontSize: 18 }}>
      Failed to load Admin Dashboard
    </h3>
    <button
      onClick={onRetry}
      style={{
        background: "#b91c1c",
        color: "#fff",
        padding: "0.55rem 1.1rem",
        borderRadius: 6,
        border: "none",
        cursor: "pointer",
        fontWeight: 600,
      }}
    >
      Retry
    </button>
  </div>
);

const AdminDashboard = ({ instituteId: propInstituteId, pageSize = 25 }) => {
  const { user } = useContext(AuthContext);
  const [instituteId, setInstituteId] = useState(propInstituteId || "");
  const [loadError, setLoadError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Resolve instituteId priority: prop > user.instituteId > localStorage > URL (?instituteId=)
  useEffect(() => {
    if (propInstituteId) {
      setInstituteId(propInstituteId);
      return;
    }
    if (user?.instituteId) {
      setInstituteId(user.instituteId);
      localStorage.setItem("instituteId", user.instituteId);
      return;
    }
    const stored = localStorage.getItem("instituteId");
    if (stored) {
      setInstituteId(stored);
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const q = params.get("instituteId");
    if (q) {
      setInstituteId(q);
      localStorage.setItem("instituteId", q);
    }
  }, [propInstituteId, user]);

  const handleError = useCallback((err) => {
    setLoadError(err?.message || "Unknown error");
  }, []);

  const handleLoadingChange = useCallback((val) => setLoading(val), []);

  const retry = () => {
    setLoadError(null);
    setInstituteId((prev) => prev);
  };


  return (
    <div style={{ position: "relative" }}>
      {loadError && (
        <div style={{ marginBottom: "1.25rem" }}>
          <ErrorBox error={loadError} onRetry={retry} />
        </div>
      )}

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 12,
            right: 12,
            background: "#111827",
            color: "#fff",
            padding: "0.55rem 0.9rem",
            fontSize: 12,
            borderRadius: 6,
            boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
            zIndex: 100,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: "#60a5fa",
              animation: "pulse 1s ease-in-out infinite",
            }}
          />
          Loading…
        </div>
      )}

      <Dashboard
        role="admin"
        instituteId={instituteId}
        pageSize={pageSize}
        serverBaseUrl={serverUrl}
        onError={handleError}
        onLoadingChange={handleLoadingChange}
        initialFilters={{}}
        disableFilters={{}}
      />
    </div>
  );
};

export default AdminDashboard;